module.exports = __webpack_public_path__ + "static/media/restaurant.270c5866.svg";